import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'
import withStyles from 'react-jss'

import WifiCredentials from 'components/ran/wifi-credentials'
import ConfirmationItem from 'components/confirmation-item'
import { withPopin, Popin, FormButtons, Button, FormError } from '@portal/kit/pkg/components'

import styles from './reset-popin-style'

class ResetPopin extends Component {
  renderResetConfirmation = () =>
    <Fragment>
      <p dangerouslySetInnerHTML={{ __html: this.props.t('ran_reset.confirm.text', { devicesCount: this.props.data.devices.length }) }} />
      <p><strong>{this.props.t('ran_reset.confirm.confirm')}</strong></p>
      <FormButtons>
        <Button classType="cancel" onClick={this.props.cancelReset}>{this.props.t('form.cancel')}</Button>
        <Button onClick={this.props.resetRoom} isLoading={this.props.isLoading}>{this.props.t('form.confirm')}</Button>
      </FormButtons>
    </Fragment>

  renderResetSuccess = () =>
    <Fragment>
      <ConfirmationItem className={this.props.classes.confirmationItem}>{this.props.t('ran_reset.success.success')}</ConfirmationItem>
      <ConfirmationItem isPending>
        <span dangerouslySetInnerHTML={{ __html: this.props.t('ran_reset.success.pending_instruction', { network: this.props.updatedRoom.ssid }) }} />
      </ConfirmationItem>
      <WifiCredentials psk={this.props.updatedRoom.psk} ssid={this.props.updatedRoom.ssid} className={this.props.classes.credentials} />
      <p>{this.props.t('ran_reset.success.email')}</p>
      <p dangerouslySetInnerHTML={{ __html: this.props.t('ran_reset.success.warning', { network: this.props.updatedRoom.ssid }) }} />
      <FormButtons>
        <Button onClick={this.props.cancelReset}>{this.props.t('popin.close')}</Button>
      </FormButtons>
    </Fragment>

  getTitle = () =>
    this.props.updatedRoom ? this.props.t('ran_reset.success.title') : this.props.t('ran_reset.confirm.title')

  render() {
    const popinProps = {
      ...this.props.popin,
      isOpened: this.props.isOpened,
      close: this.props.cancelReset
    }

    return (
      <Popin title={this.getTitle()} {...popinProps}>
        {this.props.popinError && <FormError message={this.props.popinError} />}
        {this.props.updatedRoom
          ? this.renderResetSuccess()
          : this.renderResetConfirmation()
        }
      </Popin>
    )
  }
}

ResetPopin.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  popinError: PropTypes.string,
  updatedRoom: PropTypes.object,
  data: PropTypes.object.isRequired,
  cancelReset: PropTypes.func.isRequired,
  resetRoom: PropTypes.func.isRequired,
}

export default compose(
  withPopin,
  withTranslation(),
  withStyles(styles),
)(ResetPopin)
